import { request as doRequest } from 'root/common/request.js';
import { paramToStr } from '../utils/index';

/**
 * 这里主要为了做一些特殊处理
 */
export function request(data) {
    return doRequest(data)
        .then(res => {
            // console.log('xxx', res);
            if (res.code !== 200) {
                if (res.code === 300) {
                    let loginUrl = res.data.login_url;
                    jumpToLogin(loginUrl);
                }
            }
            return res;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

// 跳转到登录页
function jumpToLogin(loginUrl) {
    let params = paramToStr({
        refer: encodeURIComponent(window.location.href),
    });
    let appendParam = loginUrl.indexOf('?') === -1 ? `?${params}` : `&${params}`;
    window.location.href = loginUrl + appendParam;
}
